import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-28" }
const _hoisted_2 = { class: "mx-auto max-w-4xl" }
const _hoisted_3 = { class: "p-6 bg-white border border-gray-200 shadow-sm rounded-2xl mb-6 mt-4" }
const _hoisted_4 = { class: "mb-4 text-xl font-semibold text-gray-900" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col gap-3 mt-4 md:flex-row md:items-center md:justify-between" }
const _hoisted_7 = { class: "space-y-3" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex items-center mr-3" }
const _hoisted_10 = ["id", "checked", "onChange"]
const _hoisted_11 = { class: "relative mr-3 inline-flex items-center justify-center w-9 h-9 overflow-hidden rounded-full bg-[#f6f1ec] border border-gray-200" }
const _hoisted_12 = { class: "text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_PlayCircleIcon = _resolveComponent("PlayCircleIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_Breadcrumb, { crumbs: _ctx.breadcrumbItems }, null, 8, ["crumbs"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.currentContent.title), 1),
        (_ctx.signedVideoUrl)
          ? (_openBlock(), _createElementBlock("video", {
              key: _ctx.signedVideoUrl,
              class: "w-full h-auto max-w-full rounded-xl border border-gray-200",
              controls: ""
            }, [
              _createElementVNode("source", {
                src: _ctx.signedVideoUrl,
                type: "video/mp4"
              }, null, 8, _hoisted_5),
              _cache[2] || (_cache[2] = _createTextVNode(" Your browser does not support the video tag. "))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-sm font-medium text-gray-700" }, " Next Video: VeEX Module Update Tutorial ", -1)),
          _createElementVNode("button", {
            class: "inline-flex items-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-[#c9ad99]",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onContentComplete(_ctx.currentModule._id, _ctx.currentContent._id)))
          }, [
            _cache[3] || (_cache[3] = _createTextVNode(" Mark as Complete ")),
            _createVNode(_component_CheckCircleIcon, { class: "ml-2 h-4 w-4" })
          ])
        ])
      ]),
      _createVNode(_component_Accordion, {
        "is-open": _ctx.currentModule.show,
        progress: _ctx.computeModuleProgress(),
        "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentModule.show = $event))
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.currentModule.title), 1)
        ]),
        "content-count": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.getContentCount(_ctx.currentModule)), 1)
        ]),
        "progress-label": _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode(" Progress ")
        ])),
        "progress-percent": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.computeModuleProgress()) + "% Complete ", 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentModule.contents, (content, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "content-item flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("input", {
                      id: 'checkbox-' + index,
                      checked: content.completed,
                      class: "w-4 h-4 rounded-full border border-gray-300 bg-white text-primary appearance-none checked:bg-primary checked:border-primary focus:ring-2 focus:ring-primary",
                      type: "checkbox",
                      onChange: ($event: any) => (_ctx.onContentComplete(_ctx.currentModule._id, content._id))
                    }, null, 40, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_PlayCircleIcon, { class: "h-5 w-5 text-gray-700" })
                  ]),
                  _createVNode(_component_router_link, {
                    to: '/dashboard/course/' + _ctx.course._id + '/' + _ctx.currentModule._id + '/' + content._id,
                    class: "text-gray-900 text-sm font-medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(content.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(content.length) + " min", 1)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["is-open", "progress"])
    ])
  ]))
}